module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-client/~/isarray/index.js
 ** module id = 402
 ** module chunks = 0
 **/